@if (!hideHeader()) {
  <yt-header [color]="headerColor()"></yt-header>
}
<p-progressbar [mode]="loading() ? 'indeterminate' : 'determinate'" [style]="{ height: '4px' }" />
@if (!hideBreadcrumbs()) {
  <yt-breadcrumbs></yt-breadcrumbs>
}

<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
<router-outlet></router-outlet>
<p-toast key="top-right"></p-toast>

<p-confirmDialog key="yt-updated-dialog" [style]="{ width: '40vw' }">
  <!--  Content code driven-->
</p-confirmDialog>
<yt-edit-profile-modal></yt-edit-profile-modal>
<yt-local-sign-in-dialog></yt-local-sign-in-dialog>
